export default function HomeIndex() {
  return (
    <div>
      Hello World!
    </div>
  );
}
